import { isEmbarcacaoImagensEmpty } from "@/modules/embarcacoes/embarcacoes.types";
import type {
  EmbarcacaoImagens,
  EmbarcacaoImagensState,
} from "@/modules/embarcacoes/embarcacoes.types";
import {
  useEmbarcacaoDetailSection,
  type EmbarcacaoDetailSectionQuery,
} from "./use-embarcacao-detail-section";

const IMAGENS_QUERY: EmbarcacaoDetailSectionQuery<EmbarcacaoImagens> = {
  select: (ficha) => ficha.imagens,
  isEmpty: isEmbarcacaoImagensEmpty,
  secao: "as Imagens",
};

interface UseEmbarcacaoImagensResult extends EmbarcacaoImagensState {
  reload: () => void;
}

/** Consulta as Imagens da embarcação pedida. Somente leitura. */
export function useEmbarcacaoImagens(id: string): UseEmbarcacaoImagensResult {
  const { data, ...state } = useEmbarcacaoDetailSection(id, IMAGENS_QUERY);

  return { ...state, imagens: data };
}
